import React, { useContext, useState } from "react";
import moment from "moment";
import { Button } from "components/buttons";
import { WalletTodayMovementsContext } from "../../context";
import { Dropdown } from "components/dropdown";
import { useDropdown } from "hooks/use-dropdown";
import DatePicker from "react-datepicker";
import { general as texts } from "assets/strings/texts";

export function HistoryFormModel({ phoneView, className }) {
  const accountsOptions = [
    /*   {
      value: "01720110791105768301",
      text: "Wallet",
      key: "wallet",
    },
    {
      value: "01720110711105768319",
      text: "Servicios",
      key: "services",
      }, */
    /*   {
      value: "01020501830003283374",
      text: "Banco de Venezuela",
      key: "bdv",
    }, */
    {
      text: "Banco de Venezuela",
      value: "01020989770000001038",
      //value: "01020010500000300292",
      key: "bdv",
    },
  ];
  const {
    bind: { onChange: onChangeAccount, value: accountSelected },
  } = useDropdown("");

  const [fromDate, setFromDate] = useState(null);
  const {
    state: { loading },
    changeState,
  } = useContext(WalletTodayMovementsContext);

  const onSubmit = (event) => {
    event.preventDefault();
    const date = moment(fromDate).format();
    changeState({
      date_from: date,
      date_to: date,
      account: accountSelected,
      submit: true,
    });
  };
  const handleFromDate = (date) => {
    setFromDate(date);
  };

  const submitDisabled = !accountSelected || loading;
  return (
    <form className={className} onSubmit={onSubmit}>
      <p className="title"> Seleccione una cuenta:</p>
      <Dropdown
        fluid
        floating
        selection
        id="account"
        value={accountSelected}
        onChange={onChangeAccount}
        options={accountsOptions}
      />
      <div className={`collapsed false`}>
        <div className="date-pickers">
          <DatePicker
            className="date-picker"
            placeholderText={texts.date}
            dateFormat={texts.shortDateFormat}
            showMonthDropdown
            showYearDropdown
            todayButton={texts.today}
            isClearable
            withPortal={phoneView}
            selected={fromDate}
            maxDate={moment()}
            onChange={handleFromDate}
          />
        </div>
      </div>

      <Button color="grey" disabled={submitDisabled}>
        Buscar
      </Button>
    </form>
  );
}
